module.exports = __webpack_public_path__ + "static/media/11.fc9da8b4.jpg";